import React, {Component} from "react";
import "./ShippingEstimate.css";
import "../../../Common/Common.css";
import {Modal} from "react-bootstrap";
import {FormattedMessage} from "react-intl";
import Select from "react-select";

const options = [
    {value: '1', label: 'Method 1'},
    {value: '2', label: 'Method 2'},
    {value: '3', label: 'Method 3'},
    {value: '4', label: 'Method 4'}
];
const currencyOptions = [
    {value: 'jpy', label: 'JPY'},
    {value: 'usd', label: 'USD'}
];

class ShippingEstimate extends Component {

    constructor(props) {
        super(props);

        this.state = {
            show: false,
            country : "",
            currency : ""
        };
    }

    handleClose = () => {
        this.setState({show: false});
    };

    handleShow = () => {
        this.setState({show: true});
    };

    render() {

        return (
            <span>
                <a className="btn btn-xs btn-default" onClick={this.handleShow}>
                    Select shipping method and currency
                </a>
                <Modal show={this.state.show} onHide={this.handleClose}>
                    <Modal.Header closeButton>
                        <div className="title-1 color-text">
                            <p className="shipping-estimate-header-text">SHIPPING METHOD & CURRENCY</p>
                        </div>
                        <div className="color-text">
                             <p className="shipping-estimate-header-text text-small">Please select your shipping destination & currency &
                    Price may differ based on your Shipping destination.</p>
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="modal-body-div color-text">
                        <div className="modal-body-div-text ">
                            Shipping method
                        </div>
                        <div>
                            <Select
                                defaultValue={this.state.country}
                                isLoading={true}
                                isSearchable={true}
                                name="country"
                                options={options}
                                onChange={this.onSelectChange}
                            />
                        </div>
                        </div>
                       <div className="modal-body-div color-text">
                       <div className="modal-body-div-text">
                            Currency
                        </div>
                        <div>
                            <Select
                                defaultValue={this.state.currency}
                                isLoading={true}
                                isSearchable={true}
                                name="country"
                                options={currencyOptions}
                                onChange={this.onSelectChange}
                            />
                        </div>
                        </div>


                    </Modal.Body>
                    <Modal.Footer>
                        <div className="col-md-6 bottom-button-left-div color-text">
                        <button className="btn btn-primary bottom-button" onClick={this.onSubmit}>
                           Save
                        </button>
                        </div>
                        <div className="col-md-6 bottom-button-right-div color-text">
                        <button className="btn btn-default bottom-button" onClick={this.handleClose}>
                           Cancel
                        </button>
                        </div>
                    </Modal.Footer>
                </Modal>
            </span>
        );
    }
}

export default ShippingEstimate;



// WEBPACK FOOTER //
// ./src/components/Site/PriceInformation/ShippingEstimate/ShippingEstimate.js